import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["tab", "tabContent"];

  connect() {
    // Activate the first tab by default if none are active
    const defaultTab = this.element.querySelector("[data-tab-name]");
    if (defaultTab) {
      this.activateTab(defaultTab.dataset.tabName);
    }
  }

  switch(event) {
    event.preventDefault();
    const selectedTabName =
      event.target?.dataset?.tabName || event.currentTarget?.dataset?.tabName;

    // Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: "smooth" });

    // Activate the selected tab
    this.activateTab(selectedTabName);
  }

  activateTab(selectedTabName) {
    // Update tab buttons
    this.element.querySelectorAll("[data-tab-name]").forEach((tab) => {
      const isActive = tab.dataset.tabName === selectedTabName;
      tab.classList.toggle("border-gray-600", isActive);
      tab.classList.toggle("text-gray-800", isActive);
      tab.classList.toggle("text-gray-600", !isActive);
      tab.classList.toggle("border-b-2", isActive); // Ensure underline is added
    });

    // Update tab content visibility
    this.element
      .querySelectorAll("[data-tab-content]")
      .forEach((tabContent) => {
        const isSelected = tabContent.dataset.tabContent === selectedTabName;
        tabContent.classList.toggle("invisible", !isSelected);
        tabContent.classList.toggle("absolute", !isSelected);
      });
  }
}
